import { computed } from "vue";
import { useStore } from "@/core/services/store";
import i18n from "@/core/plugins/vue-i18n";

/**
 * Reminder shown right before the user is redirected to a third party for
 * authentication. Users kept authorizing several integrations with the same
 * eBay account, which mixes up the data of those integrations.
 *
 * An app opts in by providing the snippet
 * `salesChannelManagementApp.<appName>.accountNotice`.
 */
export function useOauthAccountNotice() {
  const store = useStore();

  const snippetKey = computed(
    () =>
      `salesChannelManagementApp.${store.getters.selectedApp?.name}.accountNotice`
  );

  const accountNotice = computed(() =>
    i18n.te(snippetKey.value) ? i18n.t(snippetKey.value) : ""
  );

  // Same notice as a FormHelper field, for forms built from a field array
  const accountNoticeField = computed(() => {
    if (!accountNotice.value) return null;

    return {
      type: "alert",
      name: "accountNotice",
      color: "warning",
      icon: "fal fa-exclamation-triangle",
      label: accountNotice.value
    };
  });

  return {
    accountNotice,
    accountNoticeField
  };
}
